import OnboardingBookAvailableGuides from '../../../onboarding/components/OnboardingBookAvailableGuides';

const BookFirstSessionScreen = () => {
    return <OnboardingBookAvailableGuides />;
};

export default BookFirstSessionScreen;
